import { render, staticRenderFns } from "./PointsCopyComponent.vue?vue&type=template&id=01f73644"
import script from "./PointsCopyComponent.vue?vue&type=script&lang=js"
export * from "./PointsCopyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports